import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(data) {
  return request({
    url: '/admin/list',
    method: 'post',
    data: data
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

export function getList(id) {
  return request({
    url: '/admin/getAdmin/'+id,
    method: 'post',
  })
}

export function updateDeviceCode(id) {
  return request({
    url: '/admin/handleDeviceCode/'+id,
    method: 'get'
  })
}

export function updateRegistrationCode(id) {
  return request({
    url: '/admin/handleRegistrationCode/'+id,
    method: 'get'
  })
}

export function updatePasswordById(data) {
  return request({
    url: '/admin/updatePasswordById',
    method: 'Post',
    data: data
  })
}





// WEBPACK FOOTER //
// ./src/api/login.js